<template>
	<div class="content" style="background-color: var(--primary-color); border-radius: 15px;padding-bottom: 15px;">
		<router-view></router-view>
	</div>
</template>

<script>

	export default {
		components: {

		},
		mounted() {
			window.scrollTo(0,0);
		},
		created() {

		},
		methods: {
			getForm() {
				this.$http.get(this.config.api + "/user/request_form").then(res => {
					if (res.body.status == 'success') {
						this.loaded = true;
						this.user.token = res.body.data.token
						this.user.code = res.body.data.code
					}
				})
			},
		},
		computed: {
		},
		data() {
			return {
			}
		}
	}
</script>
<style>
	.game-list {
		cursor: pointer;
		border-radius: 15px;
		border: 1px solid #135F87;
		text-align: center;
	}
	.game-list:hover {
		opacity: 0.9;
	}
	.game-list-image {
		border-radius: 15px;
	}
	.page-title {
		background-color: #1c3042;
		padding: 15px 0;
		text-align:center;
		border-top-left-radius: 15px;
		border-top-right-radius: 15px;
		font-size: 15px;
		font-weight: bold;
	}
	.promotion-image {
		border-radius: 15px;
		border: 1px solid #135F87;
		margin-bottom: 15px;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Page.vue